import * as React from "react"
import { observer } from "mobx-react-lite"
import LottieReact, { LottieRefCurrentProps } from "lottie-react"
import { AnimatedLottieViewProps } from "lottie-react-native"
import { useEffect, useRef} from "react"
import { ViewStyle } from "react-native"

export interface LottieProps extends AnimatedLottieViewProps {

}

/**
 * Describe your component here
 */
export const Lottie = observer(function Lottie(props: LottieProps) {
  const { source, progress, ...rest } = props
  const otherProps: any = rest
  const lottieRef = useRef<LottieRefCurrentProps>()

  const LOTTIE: ViewStyle = {
    flexGrow: 1
  }

  useEffect(() => {
    if (typeof progress === 'number')
      lottieRef.current.goToAndPlay(progress * lottieRef.current.getDuration(true), true)
  }, [progress])

  return (
    <LottieReact
      lottieRef={lottieRef}
      animationData={source}
      style={LOTTIE}
      {...otherProps}
    />
  )
})
